
function gmCloseRemoveDialog(dialog) {
  if (dialog && dialog.open) dialog.close();
  var trigger = dialog && dialog.closest('tr') && dialog.closest('tr').querySelector('.gm-cart-remove-trigger');
  if (trigger) trigger.focus();
}

document.addEventListener('click', function (event) {
  const trigger = event.target.closest('.gm-cart-remove-trigger');
  if (trigger) {
    const row = trigger.closest('tr');
    const dialog = row && row.querySelector('.gm-cart-remove-confirm');
    if (dialog && typeof dialog.showModal === 'function') {
      dialog.showModal();
      const cancel = dialog.querySelector('.gm-cart-remove-confirm__cancel');
      if (cancel) cancel.focus();
    }
    return;
  }

  const cancelButton = event.target.closest('.gm-cart-remove-confirm__cancel');
  if (cancelButton) {
    gmCloseRemoveDialog(cancelButton.closest('.gm-cart-remove-confirm'));
    return;
  }

  if (event.target.classList && event.target.classList.contains('gm-cart-remove-confirm')) {
    gmCloseRemoveDialog(event.target);
    return;
  }

  if (event.target.closest('.gm-cart-remove-confirm__confirm')) {
    gmCloseRemoveDialog(event.target.closest('.gm-cart-remove-confirm'));
    return;
  }

  handlePromoApplyClick(event);
});

function applyDiscountViaIframe(code) {
  return new Promise(function (resolve) {
    const iframe = document.createElement('iframe');
    iframe.style.display = 'none';
    iframe.setAttribute('aria-hidden', 'true');

    let settled = false;
    function finish() {
      if (settled) return;
      settled = true;
      iframe.remove();
      resolve();
    }

    iframe.addEventListener('load', finish);

    setTimeout(finish, 2500);

    iframe.src = '/discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent('/cart');
    document.body.appendChild(iframe);
  });
}

function handlePromoApplyClick(event) {
  const applyButton = event.target.closest('#CartDrawer-DiscountApply');
  if (!applyButton) return;

  const input = document.getElementById('CartDrawer-DiscountCode');
  const code = input ? input.value.trim() : '';
  if (!code || !window.routes || !window.routes.cart_update_url) return;

  applyButton.disabled = true;

  applyDiscountViaIframe(code)
    .then(function () {
      return fetch(window.routes.cart_update_url + '?sections=cart-drawer,cart-icon-bubble', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ attributes: { discount_code: code, discount_code_live_attempted: '1' } }),
      });
    })
    .then(function (response) {
      return response.json();
    })
    .then(function (state) {
      const cartDrawer = document.querySelector('cart-drawer');
      if (cartDrawer && typeof cartDrawer.renderContents === 'function') {
        cartDrawer.renderContents(state);
      }
    })
    .finally(function () {
      applyButton.disabled = false;
    });
}

